export enum MutationKeys {
  TextEnhancement = "text-enhancement",
  Attachment = "attachment",
  LogoUpload = "logo-upload",
  OpenWidget = "openwidget",
  KnowledgeBaseIntroFlags = "knowledgeBaseIntroFlags",
}
